import survey_get_next_day from "@/views/survey/modules/survey_get_next_day";

export default async (context) => {
    if(context.select === 'ground') {

        await context.$store.dispatch('survey_price/setSelectSurveyPrice', {
            price: context.surveyGround
        })

        await context.$store.dispatch('survey_price/setSelectSurveyName', {
            name: 'Съёмка с земли',
            id: 'ground'
    })

        await context.$store.dispatch('survey_price/setBlockDates', survey_get_next_day())

    } else if(context.select === 'air') {

        await context.$store.dispatch('survey_price/setSelectSurveyPrice', {
            price: context.surveyAerial
        })

        await context.$store.dispatch('survey_price/setSelectSurveyName', {
            name: 'Съёмка с воздуха',
            id: 'air'
        })

        await context.$store.dispatch('survey_price/setBlockDates', [])

    } else if(context.select === 'ground-air') {

        await context.$store.dispatch('survey_price/setSelectSurveyPrice', {
            price: context.surveyGroundAerial
        })

        await context.$store.dispatch('survey_price/setSelectSurveyName', {
            name: 'Все виды съемок',
            id: 'ground_and_air'
        })

        await context.$store.dispatch('survey_price/setBlockDates', [])

    }

    context.$router.push('/final')
}